import http from '@/components/services/http-common';
import formatter from '@/components/services/formatter';

export const get = (from, to) => http.get('imageReports/v2?', {
  params: {
    date: [from, to]
  }
}).then(res => {
  res.data.data= res.data.data.map(x => {
    x.createdAt = formatter.formatDate(x.createdAt)
    return x
  })
  return res.data
})
